import { useEffect, useState } from "react";

import { apiClient } from "../../http";

export const useOfficeGroupsCount = (officeId, seasonId) => {
  const [ data, setData ] = useState({});
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiClient({
          method: 'GET',
          url: `/offices/${officeId}/groups/count`,
          params: { where: { seasonId } },
        })
        setData(response?.data?.count);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [ officeId, seasonId ]);

  return { data, loading, error };
}
